import { collection, doc, query, onSnapshot } from "firebase/firestore";
import { brand } from "@/constants/brandVariables/brandVariables";
import { Winner } from "@/models/winner.model";
import { useState, useEffect } from "react";

import { fullDays } from "../constants/dateLists/weekDays";
import { firestore } from "../api/firebaseConfig";

export const useWinnersData = () => {
  const [data, setData] = useState<Winner[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>();

  useEffect(() => {
    const winnersRef = collection(
      doc(collection(firestore, "event-winners"), brand.tenantId),
      "winners"
    );

    const winnersQuery = query(winnersRef);

    const unsubscribe = onSnapshot(
      winnersQuery,
      (snapshot) => {
        const winnersTempArr = snapshot.docs.map((doc) => {
          const data = doc.data() as Winner;
          return {
            ...data,
            winningDay:
              fullDays[
                new Date(data.winningDate.seconds * 1000)
                  .toDateString()
                  .split(" ")[0] as "Sun"
              ],
          };
        });

        const sortedWinners = winnersTempArr.sort(
          (a, b) => b.winningDate.seconds - a.winningDate.seconds
        );

        setData(sortedWinners);
        setLoading(false);
      },
      (error) => {
        console.error("Error fetching winners:", error);
        setError("Error fetching winners!");
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  return { loading, data, error };
};
